//Products
export const PRODUCTS_LIST = 'products';
export const PRODUCTS_STORE = 'products';

//Categories
export const CATEGORY_LIST = 'categories';

//Taxes
export const TAX_LIST = 'taxes';

//Client
export const CLIENT_LIST = 'clients';

// Invoice
export const INVOICES = 'invoices';
export const INVOICES_LIST = 'invoices/list/view';
export const INVOICES_SEND = 'invoice-send';
export const STOP_RECURRING_INVOICES = 'stop-recurring';

//Estimate
export const ESTIMATE = 'estimates';
export const ESTIMATE_LIST = 'estimates/list/view';
export const ESTIMATE_SEND = 'estimates-send';
export const ESTIMATE_NUMBER = 'get-estimate-number';

//Payment History
export const PAYMENTHISTORY = 'payment-histories';

//Expense
export const EXPENSE_LIST = 'expenses';
//Expense
export const PURPOSE_LIST = 'purposes';

//Payment History
export const RECEIPTHISTORY = 'receipt-histories';

//Bill History
export const BILLHISTORY = 'bill-histories';

// InvENTORY
export const INVENTORY = 'inventory';
export const INVENTORY_LIST = 'inventory/list/view';